import { render, staticRenderFns } from "./total-output-value.vue?vue&type=template&id=5b2c9239&scoped=true"
import script from "./total-output-value.vue?vue&type=script&lang=js"
export * from "./total-output-value.vue?vue&type=script&lang=js"
import style0 from "./total-output-value.vue?vue&type=style&index=0&id=5b2c9239&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2c9239",
  null
  
)

export default component.exports